import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormikInputGroup from '@components/smartAdminUI/input/FormikInputGroup';

// This will group the Address fields together

const Address = props => {
  const [cityField, setCityField] = useState({ FieldName: 'City' });
  const [countyField, setCountyField] = useState({ FieldName: 'CountyOrParish' });
  const [postalField, setPostalField] = useState({ FieldName: 'PostalCode' });
  const [provinceField, setProvinceField] = useState({ FieldName: 'StateOrProvince' });
  const [streetDirSufField, setStreetDirSufField] = useState({ FieldName: 'StreetDirSuffix' });
  const [streetNameField, setStreetNameField] = useState({ FieldName: 'StreetName' });
  const [streetNumField, setStreetNumField] = useState({ FieldName: 'StreetNumber' });
  const [streetSufField, setStreetSufField] = useState({ FieldName: 'StreetSuffix' });
  const [unitNumField, setUnitNumField] = useState({ FieldName: 'UnitNumber' });

  const { fields, validateFigField, comboBubbleWrap } = props;

  useEffect(() => {
    fields.forEach(field => {
      switch (field.FieldName) {
        case 'City':
          setCityField(field);
          break;
        case 'CountyOrParish':
          setCountyField(field);
          break;
        case 'PostalCode':
          setPostalField(field);
          break;
        case 'StateOrProvince':
          setProvinceField(field);
          break;
        case 'StreetDirSuffix':
          setStreetDirSufField(field);
          break;
        case 'StreetName':
          setStreetNameField(field);
          break;
        case 'StreetNumber':
          setStreetNumField(field);
          break;
        case 'StreetSuffix':
          setStreetSufField(field);
          break;
        case 'UnitNumber':
          setUnitNumField(field);
          break;
        default: break;
      }
    });
  }, [fields]);

  return (
    <>
      <div className="form-row">
        <div className="form-group col-md-4">
          <FormikInputGroup
            {...provinceField}
            key={provinceField.RowID}
            validateFigField={validateFigField}
            comboBubbleWrap={comboBubbleWrap}
          />
        </div>
        <div className="form-group col-md-4">
          <FormikInputGroup
            {...countyField}
            key={countyField.RowID}
            validateFigField={validateFigField}
            comboBubbleWrap={comboBubbleWrap}
          />
        </div>
        <div className="form-group col-md-4">
          <FormikInputGroup
            {...cityField}
            key={cityField.RowID}
            validateFigField={validateFigField}
            comboBubbleWrap={comboBubbleWrap}
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group col-md-4">
          <FormikInputGroup
            {...unitNumField}
            key={unitNumField.RowID}
            validateFigField={validateFigField}
            comboBubbleWrap={comboBubbleWrap}
          />
        </div>
        <div className="form-group col-md-4">
          <FormikInputGroup
            {...streetNumField}
            key={streetNumField.RowID}
            validateFigField={validateFigField}
            comboBubbleWrap={comboBubbleWrap}
          />
        </div>
        <div className="form-group col-md-4">
          <FormikInputGroup
            {...streetNameField}
            key={streetNameField.RowID}
            validateFigField={validateFigField}
            comboBubbleWrap={comboBubbleWrap}
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group col-md-4">
          <FormikInputGroup
            {...streetSufField}
            key={streetSufField.RowID}
            validateFigField={validateFigField}
            comboBubbleWrap={comboBubbleWrap}
          />
        </div>
        <div className="form-group col-md-4">
          <FormikInputGroup
            {...streetDirSufField}
            key={streetDirSufField.RowID}
            validateFigField={validateFigField}
            comboBubbleWrap={comboBubbleWrap}
          />
        </div>
        <div className="form-group col-md-4">
          <FormikInputGroup
            {...postalField}
            key={postalField.RowID}
            validateFigField={validateFigField}
            comboBubbleWrap={comboBubbleWrap}
          />
        </div>
      </div>
    </>
  );
};

Address.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.shape()),
  comboBubbleWrap: PropTypes.shape({
    AddComboMutator: PropTypes.func,
    setNewComboValue: PropTypes.func,
    setNewComboOptions: PropTypes.func,
  }),
  validateFigField: PropTypes.func.isRequired,
};

export default Address;
